import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import toastify styles


const useCustomAlert = () => {

  const showToast = (type, message) => {
    toast[type](message, {
      position: 'top-right', 
      autoClose: 3000, 
      hideProgressBar: false, 
      closeOnClick: true, 
      pauseOnHover: true, 
      draggable: true, 
    });
  };

  return {showToast}
};

export default useCustomAlert;
